var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportantDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_469_58645",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.757812,
    width: 21.3333,
    height: 21.3333,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_469_58645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6261 18.2204C15.4084 18.2204 15.223 18.1438 15.0697 17.9905C14.9164 17.8372 14.8398 17.6518 14.8398 17.4341V10.6752C14.8398 10.4575 14.9164 10.272 15.0697 10.1188C15.223 9.96548 15.4084 9.88884 15.6261 9.88884H19.0791C19.2967 9.88884 19.4822 9.96548 19.6355 10.1188C19.7888 10.272 19.8654 10.4575 19.8654 10.6752V17.4341C19.8654 17.6518 19.7888 17.8372 19.6355 17.9905C19.4822 18.1438 19.2967 18.2204 19.0791 18.2204H15.6261ZM15.6261 16.5452H19.0791V11.564H15.6261V16.5452ZM8.60045 18.2204C8.41158 18.2204 8.25325 18.1565 8.12547 18.0287C7.9977 17.9009 7.93381 17.7425 7.93381 17.5535C7.93381 17.3645 7.9977 17.2062 8.12547 17.0786C8.25325 16.9509 8.41158 16.8871 8.60045 16.8871H9.86545V14.6649H4.58341C4.14153 14.6649 3.76325 14.5075 3.44858 14.1929C3.1339 13.8782 2.97656 13.4999 2.97656 13.058V4.71622C2.97656 4.27434 3.1339 3.89606 3.44858 3.5814C3.76325 3.26672 4.14153 3.10938 4.58341 3.10938H16.4808C16.9227 3.10938 17.3009 3.26672 17.6156 3.5814C17.9303 3.89606 18.0876 4.27434 18.0876 4.71622V7.44442C18.0876 7.63331 18.0237 7.79164 17.896 7.9194C17.7682 8.04718 17.6099 8.11107 17.421 8.11107H15.6261C14.9138 8.11107 14.3084 8.36035 13.8099 8.85893C13.3113 9.35751 13.062 9.96292 13.062 10.6752V13.9982C13.062 14.1871 12.9981 14.3454 12.8703 14.4732C12.7426 14.601 12.5842 14.6649 12.3953 14.6649H11.1987V16.8871H12.4637C12.6526 16.8871 12.8109 16.9511 12.9387 17.0789C13.0665 17.2067 13.1304 17.3651 13.1304 17.5541C13.1304 17.7431 13.0665 17.9013 12.9387 18.029C12.8109 18.1566 12.6526 18.2204 12.4637 18.2204H8.60045Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportantDevices);
export default __webpack_public_path__ + "static/media/important_devices.7b909b7016114a6c67f53303f155e43e.svg";
export { ForwardRef as ReactComponent };